import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-431">
      <div className="max-w-5xl mx-auto" data-id="element-432">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-433">
          Lo que <span className="text-[#F97316]" data-id="element-434">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-435">
          <div className="bg-black border border-[#F97316]/30 rounded-2xl p-6" data-id="element-436">
            <h3 className="text-[#F97316] text-xl font-black mb-2" data-id="element-437">
              🏀 LOS 6 TOMOS — Para entrenadores de básquet de todas las
              categorías
            </h3>
            <div className="space-y-4 mt-5" data-id="element-438">
              <div className="flex items-center gap-3 text-white" data-id="element-439">
                <span className="text-xl" data-id="element-440">🟢</span>
                <div className="flex-1" data-id="element-441">
                  <span className="font-bold" data-id="element-442">
                    TOMO 1 — Fundamentos U10/U12
                  </span>
                  <span className="text-gray-300" data-id="element-443">
                    {' '}
                    50 sesiones · Técnica base, dribbling, pase y primeras
                    reglas
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-444">
                <span className="text-xl" data-id="element-445">🟡</span>
                <div className="flex-1" data-id="element-446">
                  <span className="font-bold" data-id="element-447">TOMO 2 — Transición U13/U15</span>
                  <span className="text-gray-300" data-id="element-448">
                    {' '}
                    50 sesiones · Sistemas, pick and roll y lectura del juego
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-449">
                <span className="text-xl" data-id="element-450">🟠</span>
                <div className="flex-1" data-id="element-451">
                  <span className="font-bold" data-id="element-452">
                    TOMO 3 — Táctica Avanzada U17/U19
                  </span>
                  <span className="text-gray-300" data-id="element-453">
                    {' '}
                    50 sesiones · Alto rendimiento formativo y gestión del
                    equipo
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-454">
                <span className="text-xl" data-id="element-455">🔴</span>
                <div className="flex-1" data-id="element-456">
                  <span className="font-bold" data-id="element-457">
                    TOMO 4 — Preparación Física en Cancha
                  </span>
                  <span className="text-gray-300" data-id="element-458">
                    {' '}
                    Protocolos físicos para todas las categorías sin sala de
                    pesas
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-459">
                <span className="text-xl" data-id="element-460">🟣</span>
                <div className="flex-1" data-id="element-461">
                  <span className="font-bold" data-id="element-462">
                    TOMO 5 — 101 Drills de Tiro y Finalizaciones
                  </span>
                  <span className="text-gray-300" data-id="element-463">
                    {' '}
                    101 drills clasificados · Todas las categorías · Todos los
                    niveles
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-464">
                <span className="text-xl" data-id="element-465">⭐</span>
                <div className="flex-1" data-id="element-466">
                  <span className="font-bold" data-id="element-467">
                    TOMO 6 — Scouting, Gestión y Comunicación
                  </span>
                  <span className="text-gray-300" data-id="element-468">
                    {' '}
                    Planillas pro · Scouting · Padres · Club · Desarrollo
                    profesional
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#F97316]/5 border border-[#F97316]/30 rounded-2xl p-8 text-center" data-id="element-469">
          <h3 className="text-[#F97316] text-xl font-black mb-6" data-id="element-470">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-471">
            <div className="flex items-start gap-2 text-left" data-id="element-472">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-473">✅</span>
              <span className="text-white text-sm" data-id="element-474">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-475">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-476">✅</span>
              <span className="text-white text-sm" data-id="element-477">
                Sesiones con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-478">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-479">✅</span>
              <span className="text-white text-sm" data-id="element-480">
                Sistema S.F.S.I. (leer 3 min antes de entrar y ejecutar)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-481">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-482">✅</span>
              <span className="text-white text-sm" data-id="element-483">
                Evaluaciones + planillas de progreso
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-484">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-485">✅</span>
              <span className="text-white text-sm" data-id="element-486">
                Fichas de seguimiento por jugador
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-487">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-488">✅</span>
              <span className="text-white text-sm" data-id="element-489">
                Variantes para categoría menor y mayor
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-490">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-491">✅</span>
              <span className="text-white text-sm" data-id="element-492">
                Adaptaciones para pocos jugadores y poco material
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-493">
              <span className="text-[#F97316] font-bold flex-shrink-0" data-id="element-494">✅</span>
              <span className="text-white text-sm" data-id="element-495">
                Español neutro — sin regionalismos — para todo el mundo de habla
                hispana
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}